import React from 'react';

export const ModernInvoicePageConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth : ['master', 'rh', 'rh_not_signer', 'director', 'funcionario'],
    routes  : [
        {
            path     : '/invoice/:id?/:status?/:message?',
            component: React.lazy(() => import('./ModernInvoicePage'))
        }
    ]
};
